// extracted by mini-css-extract-plugin
module.exports = {"customDrawer":"SideMenu_customDrawer__KqcRx"};